module.exports = __webpack_public_path__ + "static/Weretiger-ad30f88208bf2aa1a3c14bfa86cc5f09.jpg";